import { render } from "./AppShell.vue?vue&type=template&id=5d0f2d62"
import script from "./AppShell.vue?vue&type=script&lang=js"
export * from "./AppShell.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__